<div id="editor-js" class="editor scrollable"></div>

<button style="margin-top: 10px" mat-stroked-button color="primary" [mat-dialog-close]="true">
    Close
</button>